import { UPDATE_USER_WALLET_HISTORY } from "../store/types";

import { firebase } from "../config/configureFirebase";
import { onValue, off, ref, get } from "firebase/database";

export const fetchWalletHistory = () => async (dispatch) => {
  const { auth, walletHistoryRef, database } = firebase;

  const uid = auth.currentUser.uid;

  off(walletHistoryRef(uid));
  onValue(walletHistoryRef(uid), async (snapshot) => {
    const data = snapshot.val();
    if (data) {
      const arr = Object.keys(data).map((i) => {
        data[i].id = i;
        return data[i];
      });

      // Enhanced wallet history with booking data
      const enhancedArr = await Promise.all(
        arr.map(async (item) => {
          if (
            item.txRef !== "AdminCredit" &&
            item.txRef !== "Cancellation Fee"
          ) {
            try {
              // Try to fetch booking data
              const bookingRef = ref(database, `bookings/${item.txRef}`);
              const bookingSnapshot = await get(bookingRef);

              if (bookingSnapshot.exists()) {
                const bookingData = bookingSnapshot.val();
                return {
                  ...item,
                  bookingData: {
                    id: bookingData.id,
                    reference: bookingData.reference,
                    pickupAddress: bookingData.pickupAddress,
                    dropAddress: bookingData.dropAddress,
                    customer_name: bookingData.customer_name,
                    customer_phone: bookingData.customer_phone,
                    customer_email: bookingData.customer_email,
                    customer_address: bookingData.customer_address,
                    customer_city: bookingData.customer_city,
                    customer_state: bookingData.customer_state,
                    customer_zip: bookingData.customer_zip,
                    customer_country: bookingData.customer_country,
                    driver_name: bookingData.driver_name,
                    vehicle_number: bookingData.vehicle_number,
                    status: bookingData.status,
                    tripdate: bookingData.tripdate,
                    carType: bookingData.carType,
                    category: bookingData.category,
                    customer_paid: bookingData.customer_paid,
                    trip_cost: bookingData.trip_cost,
                  },
                };
              }
            } catch (error) {
              console.log(
                "Error fetching booking data for txRef:",
                item.txRef,
                error
              );
            }
          }
          return item;
        })
      );

      dispatch({
        type: UPDATE_USER_WALLET_HISTORY,
        payload: enhancedArr.reverse(),
      });
    } else {
      dispatch({
        type: UPDATE_USER_WALLET_HISTORY,
        payload: [],
      });
    }
  });
};
